import { render, staticRenderFns } from "./ContestacoesWebcheckout.vue?vue&type=template&id=3b7714e2&scoped=true&"
import script from "./ContestacoesWebcheckout.vue?vue&type=script&lang=js&"
export * from "./ContestacoesWebcheckout.vue?vue&type=script&lang=js&"
import style0 from "./ContestacoesWebcheckout.vue?vue&type=style&index=0&id=3b7714e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7714e2",
  null
  
)

export default component.exports